import type { AnnouncementRouter } from "replo-publisher/src/trpc/routers/announcement";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: announcementRouter,
  client: announcementClient,
  utils: announcementUtils,
  options: announcementOptions,
} = createTrpcRouterConfig<AnnouncementRouter>({
  path: "announcement",
  queryClient: getNamespacedQueryClient("announcement"),
});

export {
  announcementClient,
  announcementRouter,
  announcementUtils,
  announcementOptions,
};
